import * as Yup from 'yup';

export const editValidationSchema = Yup.object({
    status: Yup.string().required(),
});
